import {
  initialState,
  Actions,
  State,
  SELECT_ONE_FACTURACION,
  SELECT_ONE_FACTURACION_SUCCESS,
  SELECT_ONE_FACTURACION_ERROR,
  RESET_SELECT_ONE_FACTURACION,
} from "../../types/facturacion/selectOne";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SELECT_ONE_FACTURACION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case SELECT_ONE_FACTURACION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case SELECT_ONE_FACTURACION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_SELECT_ONE_FACTURACION:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
